import axiosPublicClient from "../../../../../../axiosPublicClient"

// Lazily fetch a short-lived presigned view URL for an uploaded additional document. The private
// S3 object can no longer be opened by a direct link, so the presigned URL is requested on demand
// when the candidate clicks "View file". `requestKey` is the form token used for the upload.
const service = async ({ requestKey, documentKey }) => {
    const response = await axiosPublicClient.post('/pre-check-additional-document-url', {
        key: requestKey,
        documentKey,
    })
    return response.data
}

export default service
